import { Grid } from "@mui/material";
import { FastField } from "formik";
import {
  MySelect,
  MyTextField
} from "../../Lib/componentLibrarys";

export const FormNhap = ({ values, errors, setFieldValue, phanLoaiList, linhVucList }) => {
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={12}>
          <MySelect
            required
            label="Phân loại:"
            placeholder="Chọn..."
            value={values?.phanLoai}
            options={phanLoaiList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`phanLoai`, value);
            }}
            errors={errors?.phanLoai}
            helperText={errors?.phanLoai}
          />
        </Grid>
        <Grid item xs={12}>
          <MySelect
            required
            label="Lĩnh vực:"
            placeholder="Chọn..."
            value={values?.linhVuc}
            options={linhVucList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`linhVuc`, value);
            }}
            errors={errors?.linhVuc}
            helperText={errors?.linhVuc}
          />
        </Grid>
        <Grid item xs={12}>
          <FastField name="name">
            {({ field }) => (
              <MyTextField
                required
                label="Tên nhóm người dùng:"
                placeholder="Nhập..."
                errors={errors?.name}
                helperText={errors?.name}
                {...field}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};
